// extracted by mini-css-extract-plugin
module.exports = {"cont":"Ads_cont__fSG7V","removeAds":"Ads_removeAds__EVGz4"};